import {GenericService, ResultType} from '@/shared/xhttp';
import {Client} from '@/models';

export class ClientService extends GenericService<Client> {
}